import $ from 'jquery'; 

$(document).ready(()=>{
    $('.view').fadeOut()
    $(".view").css({
        "opacity":0
    })
})